import { render, staticRenderFns } from "./BarCodeSample.vue?vue&type=template&id=32d5381e"
import script from "./BarCodeSample.vue?vue&type=script&lang=js"
export * from "./BarCodeSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports